import { Box, Button, Text, VStack } from 'native-base'
import { useNavigate } from 'react-router-dom'

import { colors } from '../../utils/theme/configureTheme'
import { IssueSubmissionResult, IssueType } from '../ReportIssue/types'
import SubmissionBody from './SubmissionBody'
import SubmissionHeader from './SubmissionHeader'
import { IssueData } from './types'
import { getHeaderContent, getHeaderType } from './utils'

interface IssueSubmissionProps {
  issueData: IssueData
}

/** Confirmation screen displayed after a consumer successfully submits a delivery issue report. */
export default function IssueSubmission({ issueData }: IssueSubmissionProps) {
  const navigate = useNavigate()

  const headerType = getHeaderType(issueData?.issueSubmissionResult || IssueSubmissionResult.SUCCESS)
  const headerContent = getHeaderContent(
    issueData?.issueSubmissionResult || IssueSubmissionResult.SUCCESS,
    issueData?.taskCreated
  )

  return (
    <VStack width="100%" space={4}>
      <SubmissionHeader
        headerType={headerType}
        headerText={headerContent.headerText}
        headerBodyText={headerContent.headerBodyText}
      />
      <Box width="100%" backgroundColor={colors.brand.white} px={4} py={4} borderRadius={8}>
        <SubmissionBody
          issueId={issueData?.issueId || ''}
          imageData={issueData?.imageData}
          issueType={(issueData?.issueType as IssueType) || IssueType.OTHER}
          issueDetail={issueData?.issueDetail || ''}
          name={issueData?.name}
          email={issueData?.email}
          cellPhone={issueData?.cellPhone}
        />
      </Box>
      <Button
        onPress={() => {
          if (issueData?.trackingId) {
            navigate(`/trackingId/${issueData.trackingId}`)
          }
        }}
        variant="solid"
        borderRadius={100}
        bgColor={colors.brand.vermillion}
        _text={{
          color: colors.brand.white,
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '125%',
          letterSpacing: '-1%',
          fontFamily: 'Matter Regular',
        }}
        py={2}
        px={4}
        maxWidth="300px"
        width="75%"
        alignSelf="center"
      >
        <Text fontSize={16} fontWeight={600} color={colors.brand.white}>
          View Tracking Page
        </Text>
      </Button>
    </VStack>
  )
}

export type { IssueData } from './types'
